import {
  UPDATE_ACCOUNT_NOTIFICATIONS_MUTATION,
  UPDATE_CUSTOMER_NOTIFICATIONS_MUTATION,
  UPDATE_PHONES_MUTATION,
} from '@src/gql/Mutations'
import { MOCK_MCN } from './utils/mockServerMocks'
import { CUSTOMER_DATA_QUERY, PROFILE_INFORMATION_QUERY } from '@src/gql/Queries'
import {
  ApplicantCode,
  Fc__AccountNotificationChannel,
  Fc__AccountNotificationType,
  Fc__CustomerNotificationChannel,
  Fc__CustomerNotificationType,
  FcFinSimpleGrowProfileAccountsByMcnQuery,
  FcFinSimpleGrowProfileCustomerAccountRelationQuery,
  Fmcc__PhoneCategory,
  Fmcc__PhoneLocation,
  Fmcc__PhoneType,
  SystemName,
} from '@src/__generated__/graphql'

export const MOCK_ACCOUNT: FcFinSimpleGrowProfileAccountsByMcnQuery = {
  fmcc: {
    account: {
      accountsByMCN: [
        {
          accountNumber: 12345678,
          accountStatus: 'Good standing',
          companyBusinessCode: 1,
          accountStatusCode: 20,
          applicantType: 'PR',
          vehicleIdentificationNumber: '1FMCU0F75KUA29233',
          vehicleNickname: 'Big Blue',
          vehicleMake: 'Ford',
          vehicleModel: 'Expedition',
          vehicleYear: 2023,
          garagingAddress: {
            addressLine1: '789 Cr.',
            addressLine2: null,
            city: 'Anchorage',
            country: 'USA',
            state: 'AK',
            zip: '99501',
          },
        },
        {
          accountNumber: 987654321,
          accountStatus: 'Good standing',
          companyBusinessCode: 1,
          accountStatusCode: 20,
          applicantType: 'CO',
          vehicleIdentificationNumber: '1FMCU0F75KUA99999',
          vehicleNickname: 'Little Red',
          vehicleMake: 'Ford',
          vehicleModel: 'Mustang',
          vehicleYear: 2019,
        },
      ],
    },
    payment: {
      multiPaymentInformation: {
        multiPaymentAccountInformation: [
          {
            account: {
              id: 12345678,
            },
            paymentEligibilityDetails: {
              isCombinedBillingAccount: false,
              isAutoPayEnrolled: false,
              isPayrollDeduct: false,
              isInBankruptcy: false,
              isAccountClosed: false,
            },
          },
          {
            account: {
              id: 987654321,
            },
            paymentEligibilityDetails: {
              isCombinedBillingAccount: true,
              isAutoPayEnrolled: true,
              isPayrollDeduct: true,
              isInBankruptcy: true,
              isAccountClosed: true,
            },
          },
        ],
      },
    },
  },
}

export const QUERY_MOCKS = [
  {
    request: {
      query: CUSTOMER_DATA_QUERY,
      variables: {
        mcn: MOCK_MCN,
        masterCustomerNumber: Number(MOCK_MCN),
        country: 'US',
      },
    },
    result: {
      data: {
        fmcc: {
          account: {
            accountsByMCN: [
              {
                accountNumber: 12345678,
                accountStatus: 'Good standing',
                companyBusinessCode: 1,
                accountStatusCode: 20,
                applicantType: 'PR',
                vehicleIdentificationNumber: '1FMCU0F75KUA29233',
                vehicleNickname: 'Big Blue',
                vehicleMake: 'Ford',
                vehicleModel: 'Expedition',
                vehicleYear: 2023,
                garagingAddress: {
                  addressLine1: '789 Cr.',
                  addressLine2: null,
                  city: 'Anchorage',
                  country: 'USA',
                  state: 'AK',
                  zip: '99501',
                },
              },
              {
                accountNumber: 987654321,
                accountStatus: 'Good standing',
                companyBusinessCode: 1,
                accountStatusCode: 20,
                applicantType: 'CO',
                vehicleIdentificationNumber: '1FMCU0F75KUA99999',
                vehicleNickname: 'Little Red',
                vehicleMake: 'Ford',
                vehicleModel: 'Mustang',
                vehicleYear: 2019,
                garagingAddress: {
                  addressLine1: '343 Cr.',
                  addressLine2: null,
                  city: 'South York',
                  country: 'USA',
                  state: 'AK',
                  zip: '99501',
                },
              },
            ],
          },
          payment: {
            multiPaymentInformation: {
              multiPaymentAccountInformation: [
                {
                  account: {
                    id: 12345678,
                  },
                  paymentEligibilityDetails: {
                    isCombinedBillingAccount: false,
                    isAutoPayEnrolled: false,
                    isPayrollDeduct: false,
                    isInBankruptcy: false,
                    isAccountClosed: false,
                  },
                },
                {
                  account: {
                    id: 987654321,
                  },
                  paymentEligibilityDetails: {
                    isCombinedBillingAccount: true,
                    isAutoPayEnrolled: true,
                    isPayrollDeduct: true,
                    isInBankruptcy: true,
                    isAccountClosed: true,
                  },
                },
              ],
            },
          },
        },
      },
    },
    maxUsageCount: Number.POSITIVE_INFINITY,
  },
  {
    request: {
      query: PROFILE_INFORMATION_QUERY,
      variables: {
        accountNumber: 12345678,
        applicantCode: ApplicantCode.Pr,
      },
    },
    result: {
      data: {
        fmcc: {
          customer: {
            customerAccountRelation: {
              account: {
                id: 12345678,
                garagingAddress: {
                  addressLine1: '789 Cr.',
                  addressLine2: null,
                  city: 'Anchorage',
                  country: 'USA',
                  state: 'AK',
                  zip: '99501',
                },
              },
              customerProfile: {
                id: '34708355',
                firstName: 'Princess',
                lastName: 'Peach',
                companyName: 'Peach Plumbing',
                digitalCommunications: [
                  {
                    text: 'TEST-UPDATE@FORD.COM',
                  },
                ],
                billingAddress: {
                  addressLine1: '123 ST.',
                  addressLine2: 'APT 1',
                  city: 'QWIK CITY',
                  state: 'MI',
                  zip: '48001',
                  country: 'USA',
                },
                phoneNumbers: [
                  {
                    phoneNumber: '1234567890',
                    extension: null,
                    phoneType: Fmcc__PhoneType.Primary,
                    phoneLocation: Fmcc__PhoneLocation.Home,
                    phoneCategory: Fmcc__PhoneCategory.Mobile,
                    sequenceNumber: 1,
                    phoneIDNumber: '24678578',
                  },
                  {
                    phoneNumber: '3345241343',
                    extension: null,
                    phoneType: Fmcc__PhoneType.Secondary,
                    phoneLocation: Fmcc__PhoneLocation.Other,
                    phoneCategory: Fmcc__PhoneCategory.Mobile,
                    sequenceNumber: 2,
                    phoneIDNumber: '33395638',
                  },
                  {
                    phoneNumber: '8734974893',
                    extension: null,
                    phoneType: Fmcc__PhoneType.Other,
                    phoneLocation: Fmcc__PhoneLocation.Other,
                    phoneCategory: Fmcc__PhoneCategory.Mobile,
                    sequenceNumber: 3,
                    phoneIDNumber: '33395638',
                  },
                  {
                    phoneNumber: '3457764260',
                    extension: null,
                    phoneType: Fmcc__PhoneType.Other,
                    phoneLocation: Fmcc__PhoneLocation.Other,
                    phoneCategory: Fmcc__PhoneCategory.Mobile,
                    sequenceNumber: 4,
                    phoneIDNumber: '33395638',
                  },
                ],
              },
              notificationPreferences: {
                customerPreferredChannel: null,
                customerPreferences: [
                  {
                    permissionType: 'Marketing',
                    channel: 'Email',
                    permission: false,
                    paymentReminderDaysPrior: 5,
                    phoneValidated: true,
                    phoneIdNumber: '24678578',
                  },
                ],
                accountPreferences: [
                  {
                    preferences: [
                      {
                        permissionType: 'ElectronicCorrespondence',
                        channel: 'Email',
                        permission: false,
                        paymentReminderDaysPrior: 5,
                        phoneValidated: true,
                        phoneIdNumber: '24678578',
                        permissionHistory: [
                          { actualRequestTimestamp: '2021-09-01T00:00:00Z', updateTimestamp: '2021-09-01T00:00:00Z' },
                        ],
                      },
                    ],
                    account: {
                      id: 12345678,
                    },
                  },
                ],
              },
            },
          },
        },
      },
    },
    maxUsageCount: Number.POSITIVE_INFINITY,
  },
  {
    request: {
      query: PROFILE_INFORMATION_QUERY,
      variables: {
        accountNumber: 987654321,
        applicantCode: ApplicantCode.Co,
      },
    },
    result: {
      data: {
        fmcc: {
          customer: {
            customerAccountRelation: {
              account: {
                garagingAddress: {
                  addressLine1: '456 Lane.',
                  addressLine2: null,
                  city: 'Karakura Town',
                  country: 'USA',
                  state: 'MI',
                  zip: '48203',
                },
              },
              applicantCode: 'PR',
              customerProfile: {
                id: '67567567',
                bankAccounts: [],
                firstName: 'Turtle',
                lastName: 'Bowser',
                companyName: 'World Takeover',
                country: 'US',
                customerType: 'COMMERCIAL',
                title: null,
                generation: null,
                customerCountryCode: 'US',
                writtenLanguageOfChoiceCode: 'EN',
                receivableCustomerNumber: '57476075',
                digitalCommunications: [],
                billingAddress: {
                  addressLine1: '123 ST.',
                  addressLine2: 'APT 1',
                  addressLine3: null,
                  city: 'QWIK CITY',
                  state: 'MI',
                  zip: '48001',
                  country: 'USA',
                  addressSequenceNumber: 1,
                  addressTypeCode: 'BILLING_ADDRESS',
                },
                phoneNumbers: [
                  {
                    phoneNumber: '1234567890',
                    extension: null,
                    phoneType: Fmcc__PhoneType.Primary,
                    phoneLocation: Fmcc__PhoneLocation.Home,
                    phoneCategory: Fmcc__PhoneCategory.Mobile,
                    sequenceNumber: 1,
                    phoneIDNumber: '24678578',
                  },
                ],
              },
              notificationPreferences: {
                customerPreferences: [
                  {
                    permissionType: 'Marketing',
                    channel: 'Email',
                    permission: true,
                  },
                ],
                accountPreferences: [
                  {
                    preferences: [
                      {
                        permissionType: 'ElectronicCorrespondence',
                        channel: 'Email',
                        permission: false,
                      },
                      {
                        permissionType: 'PaperlessBilling',
                        channel: 'Email',
                        permission: false,
                      },
                      {
                        permissionType: 'OnlineStatementAvailability',
                        channel: 'Email',
                        permission: false,
                      },
                      {
                        permissionType: 'OnlineStatementAvailability',
                        channel: 'Sms',
                        permission: false,
                      },
                      {
                        permissionType: 'OnlineStatementAvailability',
                        channel: 'Email',
                        permission: true,
                      },
                      {
                        permissionType: 'OnlineStatementAvailability',
                        channel: 'Sms',
                        permission: true,
                      },
                      {
                        permissionType: 'PaymentReminder',
                        channel: 'Email',
                        permission: false,
                      },
                      {
                        permissionType: 'PaymentReminder',
                        channel: 'Email',
                        permission: true,
                      },
                      {
                        permissionType: 'PaymentReminder',
                        channel: 'Sms',
                        permission: false,
                      },
                      {
                        permissionType: 'PaymentReminder',
                        channel: 'Sms',
                        permission: true,
                      },
                      {
                        permissionType: 'PaymentReceived',
                        channel: 'Email',
                        permission: false,
                      },
                      {
                        permissionType: 'PaymentReceived',
                        channel: 'Sms',
                        permission: false,
                      },
                    ],
                    account: {
                      id: 987654321,
                    },
                  },
                ],
              },
            },
          },
        },
      },
    },
    maxUsageCount: Number.POSITIVE_INFINITY,
  },
  {
    request: {
      query: UPDATE_CUSTOMER_NOTIFICATIONS_MUTATION,
      variables: {
        input: {
          parameters: {
            companyBusinessCode: 1,
            masterCustomerNumber: Number(MOCK_MCN),
            updatedBy: SystemName.Amo,
          },
          preferences: [
            {
              channel: Fc__CustomerNotificationChannel.Email,
              enabled: true,
              notificationType: Fc__CustomerNotificationType.Marketing,
            },
          ],
        },
      },
    },
    result: {
      data: {
        fc__customer__updateNotificationPreferences: { success: true, code: 204, message: 'success' },
      },
    },
    maxUsageCount: Number.POSITIVE_INFINITY,
  },
  {
    request: {
      query: UPDATE_ACCOUNT_NOTIFICATIONS_MUTATION,
      variables: {
        input: {
          parameters: {
            accountNumber: '12345678',
            companyBusinessCode: 1,
            masterCustomerNumber: Number(MOCK_MCN),
            updatedBy: SystemName.Amo,
          },
          preferences: [
            {
              channel: Fc__AccountNotificationChannel.Email,
              enabled: false,
              notificationType: Fc__AccountNotificationType.PaymentReminder,
              paymentReminderDays: 5,
            },
            {
              channel: Fc__AccountNotificationChannel.Sms,
              enabled: true,
              notificationType: Fc__AccountNotificationType.PaymentReminder,
              paymentReminderDays: 5,
              phoneIdNumber: 24678578,
            },
          ],
        },
      },
    },
    result: {
      data: {
        fc__account__updateNotificationPreferences: { success: true, code: 204, message: 'success' },
      },
    },
    maxUsageCount: Number.POSITIVE_INFINITY,
  },
  {
    request: {
      query: UPDATE_ACCOUNT_NOTIFICATIONS_MUTATION,
      variables: {
        input: {
          parameters: {
            accountNumber: '12345678',
            companyBusinessCode: 1,
            masterCustomerNumber: Number(MOCK_MCN),
            updatedBy: SystemName.Amo,
          },
          preferences: [
            {
              channel: Fc__AccountNotificationChannel.Email,
              enabled: true,
              notificationType: Fc__AccountNotificationType.OnlineStatementAvailability,
              phoneIdNumber: 0,
            },
          ],
        },
      },
    },
    result: {
      data: {
        fc__account__updateNotificationPreferences: { success: true, code: 204, message: 'success' },
      },
    },
    maxUsageCount: Number.POSITIVE_INFINITY,
  },
  {
    request: {
      query: UPDATE_ACCOUNT_NOTIFICATIONS_MUTATION,
      variables: {
        input: {
          parameters: {
            accountNumber: '12345678',
            companyBusinessCode: 1,
            masterCustomerNumber: Number(MOCK_MCN),
            updatedBy: SystemName.Amo,
          },
          preferences: [
            {
              channel: Fc__AccountNotificationChannel.Email,
              enabled: true,
              notificationType: Fc__AccountNotificationType.OnlineStatementAvailability,
              phoneIdNumber: undefined,
            },
          ],
        },
      },
    },
    result: {
      data: {
        fc__account__updateNotificationPreferences: { success: true, code: 204, message: 'success' },
      },
    },
    maxUsageCount: Number.POSITIVE_INFINITY,
  },
  {
    request: {
      query: UPDATE_ACCOUNT_NOTIFICATIONS_MUTATION,
      variables: {
        input: {
          parameters: {
            accountNumber: '12345678',
            companyBusinessCode: 1,
            masterCustomerNumber: Number(MOCK_MCN),
            updatedBy: SystemName.Amo,
          },
          preferences: [
            {
              channel: Fc__AccountNotificationChannel.Email,
              enabled: true,
              notificationType: Fc__AccountNotificationType.OnlineStatementAvailability,
              phoneIdNumber: 0,
            },
          ],
        },
      },
    },
    result: {
      data: {
        fc__account__updateNotificationPreferences: { success: true, code: 204, message: 'success' },
      },
    },
    maxUsageCount: Number.POSITIVE_INFINITY,
  },
  {
    request: {
      query: UPDATE_ACCOUNT_NOTIFICATIONS_MUTATION,
      variables: {
        input: {
          parameters: {
            accountNumber: '12345678',
            companyBusinessCode: 1,
            masterCustomerNumber: Number(MOCK_MCN),
            updatedBy: SystemName.Amo,
          },
          preferences: [
            {
              channel: Fc__AccountNotificationChannel.Sms,
              enabled: true,
              notificationType: Fc__AccountNotificationType.OnlineStatementAvailability,
              phoneIdNumber: 24678578,
            },
          ],
        },
      },
    },
    result: {
      data: {
        fc__account__updateNotificationPreferences: { success: true, code: 204, message: 'success' },
      },
    },
    maxUsageCount: Number.POSITIVE_INFINITY,
  },
  {
    request: {
      query: UPDATE_ACCOUNT_NOTIFICATIONS_MUTATION,
      variables: {
        input: {
          parameters: {
            accountNumber: '12345678',
            companyBusinessCode: 1,
            masterCustomerNumber: Number(MOCK_MCN),
            updatedBy: SystemName.Amo,
          },
          preferences: [
            {
              channel: Fc__AccountNotificationChannel.Sms,
              enabled: true,
              notificationType: Fc__AccountNotificationType.OnlineStatementAvailability,
              phoneIdNumber: undefined,
            },
          ],
        },
      },
    },
    result: {
      data: {
        fc__account__updateNotificationPreferences: { success: true, code: 204, message: 'success' },
      },
    },
    maxUsageCount: Number.POSITIVE_INFINITY,
  },
  {
    request: {
      query: UPDATE_ACCOUNT_NOTIFICATIONS_MUTATION,
      variables: {
        input: {
          parameters: {
            accountNumber: '12345678',
            companyBusinessCode: 1,
            masterCustomerNumber: Number(MOCK_MCN),
            updatedBy: SystemName.Amo,
          },
          preferences: [
            {
              channel: Fc__AccountNotificationChannel.Email,
              enabled: false,
              notificationType: Fc__AccountNotificationType.PaymentReminder,
              paymentReminderDays: 5,
            },
            {
              channel: Fc__AccountNotificationChannel.Sms,
              enabled: true,
              notificationType: Fc__AccountNotificationType.PaymentReminder,
              paymentReminderDays: 5,
              phoneIdNumber: 24678578,
            },
          ],
        },
      },
    },
    result: {
      data: {
        fc__account__updateNotificationPreferences: { success: true, code: 204, message: 'success' },
      },
    },
    maxUsageCount: Number.POSITIVE_INFINITY,
  },
  {
    request: {
      query: UPDATE_ACCOUNT_NOTIFICATIONS_MUTATION,
      variables: {
        input: {
          parameters: {
            accountNumber: '12345678',
            companyBusinessCode: 1,
            masterCustomerNumber: Number(MOCK_MCN),
            updatedBy: SystemName.Amo,
          },
          preferences: [
            {
              channel: Fc__AccountNotificationChannel.Email,
              enabled: true,
              notificationType: Fc__AccountNotificationType.PaymentReminder,
              paymentReminderDays: 5,
            },
          ],
        },
      },
    },
    result: {
      data: {
        fc__account__updateNotificationPreferences: { success: true, code: 204, message: 'success' },
      },
    },
    maxUsageCount: Number.POSITIVE_INFINITY,
  },
  {
    request: {
      query: UPDATE_ACCOUNT_NOTIFICATIONS_MUTATION,
      variables: {
        input: {
          parameters: {
            accountNumber: '12345678',
            companyBusinessCode: 1,
            masterCustomerNumber: Number(MOCK_MCN),
            updatedBy: SystemName.Amo,
          },
          preferences: [
            {
              channel: Fc__AccountNotificationChannel.Email,
              enabled: true,
              notificationType: Fc__AccountNotificationType.PaymentReminder,
              paymentReminderDays: 5,
            },
            {
              channel: Fc__AccountNotificationChannel.Sms,
              enabled: true,
              notificationType: Fc__AccountNotificationType.PaymentReminder,
              paymentReminderDays: 5,
              phoneIdNumber: 24678578,
            },
          ],
        },
      },
    },
    result: {
      data: {
        fc__account__updateNotificationPreferences: { success: true, code: 204, message: 'success' },
      },
    },
    maxUsageCount: Number.POSITIVE_INFINITY,
  },
  {
    request: {
      query: UPDATE_ACCOUNT_NOTIFICATIONS_MUTATION,
      variables: {
        input: {
          parameters: {
            accountNumber: '12345678',
            companyBusinessCode: 1,
            masterCustomerNumber: Number(MOCK_MCN),
            updatedBy: SystemName.Amo,
          },
          preferences: [
            {
              channel: Fc__AccountNotificationChannel.Email,
              enabled: true,
              notificationType: Fc__AccountNotificationType.PaymentReminder,
              paymentReminderDays: 5,
            },
            {
              channel: Fc__AccountNotificationChannel.Sms,
              enabled: true,
              notificationType: Fc__AccountNotificationType.PaymentReminder,
              paymentReminderDays: 5,
              phoneIdNumber: 24678578,
            },
          ],
        },
      },
    },
    result: {
      data: {
        fc__account__updateNotificationPreferences: { success: true, code: 204, message: 'success' },
      },
    },
    maxUsageCount: Number.POSITIVE_INFINITY,
  },
  {
    request: {
      query: UPDATE_ACCOUNT_NOTIFICATIONS_MUTATION,
      variables: {
        input: {
          parameters: {
            accountNumber: '12345678',
            companyBusinessCode: 1,
            masterCustomerNumber: Number(MOCK_MCN),
            updatedBy: SystemName.Amo,
          },
          preferences: [
            {
              channel: Fc__AccountNotificationChannel.Email,
              enabled: false,
              notificationType: Fc__AccountNotificationType.PaymentReceived,
              paymentReminderDays: 5,
            },
          ],
        },
      },
    },
    result: {
      data: {
        fc__account__updateNotificationPreferences: { success: true, code: 204, message: 'success' },
      },
    },
    maxUsageCount: Number.POSITIVE_INFINITY,
  },
  {
    request: {
      query: UPDATE_ACCOUNT_NOTIFICATIONS_MUTATION,
      variables: {
        input: {
          parameters: {
            accountNumber: '12345678',
            companyBusinessCode: 1,
            masterCustomerNumber: Number(MOCK_MCN),
            updatedBy: SystemName.Amo,
          },
          preferences: [
            {
              channel: Fc__AccountNotificationChannel.Sms,
              enabled: true,
              notificationType: Fc__AccountNotificationType.PaymentReceived,
              phoneIdNumber: 24678578,
            },
          ],
        },
      },
    },
    result: {
      data: {
        fc__account__updateNotificationPreferences: { success: true, code: 204, message: 'success' },
      },
    },
    maxUsageCount: Number.POSITIVE_INFINITY,
  },
  {
    request: {
      query: UPDATE_ACCOUNT_NOTIFICATIONS_MUTATION,
      variables: {
        input: {
          parameters: {
            accountNumber: '12345678',
            companyBusinessCode: 1,
            masterCustomerNumber: Number(MOCK_MCN),
            updatedBy: SystemName.Amo,
          },
          preferences: [
            {
              channel: Fc__AccountNotificationChannel.Sms,
              enabled: true,
              notificationType: Fc__AccountNotificationType.PaymentReceived,
              phoneIdNumber: 33395638,
            },
          ],
        },
      },
    },
    result: {
      data: {
        fc__account__updateNotificationPreferences: { success: true, code: 204, message: 'success' },
      },
    },
    maxUsageCount: Number.POSITIVE_INFINITY,
  },
  {
    request: {
      query: UPDATE_ACCOUNT_NOTIFICATIONS_MUTATION,
      variables: {
        input: {
          parameters: {
            accountNumber: '12345678',
            companyBusinessCode: 1,
            masterCustomerNumber: Number(MOCK_MCN),
            updatedBy: SystemName.Amo,
          },
          preferences: [
            {
              channel: Fc__AccountNotificationChannel.Sms,
              enabled: true,
              notificationType: Fc__AccountNotificationType.PaymentReceived,
              phoneIdNumber: undefined,
            },
          ],
        },
      },
    },
    result: {
      data: {
        fc__account__updateNotificationPreferences: { success: true, code: 204, message: 'success' },
      },
    },
    maxUsageCount: Number.POSITIVE_INFINITY,
  },

  {
    request: {
      query: UPDATE_PHONES_MUTATION,
      variables: {
        input: {
          parameters: {
            companyBusinessCode: 1,
            accountNumber: 12345678,
            applicantCode: 'PR',
            requestUserID: 'SYSAM',
            contactActivity: {
              who: 5,
              type: 203,
              rootCause: 4,
              result: 214,
              reason: 7,
              comments: 'Previous Phone details deleted: 1234567890 ext. 123',
              category: 22,
            },
            branchCode: 'MR',
            applicationSourceCode: 'ACCOUNT_MANAGER',
            systemName: SystemName.Amo,
          },
          phoneRequest: [
            {
              phone: {
                phoneAreaCode: '123',
                phoneNumber: '4567890',
                category: 'LANDLINE',
                location: 'HOME',
                sequenceNumber: 1,
                phoneExtension: '123',
              },
              action: 'DEL',
            },
          ],
        },
      },
    },
    result: {
      data: {
        fmcc__customer__updatePhones: {
          success: true,
          code: 200,
          message: 'Phone deleted successfully',
        },
      },
    },
  },
]

export const MOCK_PROFILE: FcFinSimpleGrowProfileCustomerAccountRelationQuery = QUERY_MOCKS[1].result.data
